import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import Tr from './tr';
import RulerIcon from '../../assets/image/general/general_pressure_map.svg';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'inline-block',
    },
    title: {
      fontFamily: 'Arial',
      fontWeight: 'bold',
      fontSize: 14,
      textAlign: 'right',
      display: 'block',
    },
    txt: {
      textAlign: 'right',
      display: 'block',
      fontFamily: 'Arial',
      fontSize: 12,
    },
    img: {
      height: 254,
      width: 'auto',
    },
  })
);

export default function OcclusionProximityRuler() {
  const classes = useStyles();
  const tr = new Tr();
  const separator = <div style={{ height: 28 }} />;
  const gridLabel = (title: string, clr: string) => {
    return (
      <Grid>
        <label className={classes.txt} style={{ color: clr }}>
          {title}
        </label>
      </Grid>
    );
  };

  return (
    <div className={classes.root}>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <label className={classes.title}>{tr.occlusionProximity()}</label>
        </Grid>
        <Grid container direction="row" item spacing={2} justify="flex-end">
          <Grid item>
            <div style={{ height: 10 }} />
            {gridLabel(tr.occlusionCollision(), '#B700B7')}
            {separator}
            {gridLabel(tr.occlusionContact(), '#EB1414')}
            {separator}
            {gridLabel(tr.occlusionStrong(), '#E88714')}
            {separator}
            {gridLabel(tr.occlusionAverage(), '#EBCC14')}
            {separator}
            {gridLabel(tr.occlusionWeak(), '#BDF514')}
            {separator}
            {gridLabel(tr.occlusionVeryWeak(), '#14E8BD')}
          </Grid>
          <Grid item>
            <img src={RulerIcon} className={classes.img} />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
